export default "__VITE_ASSET__Dr_vEt68__"